import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { Link, type LinkProps, LinkType } from "~/common/components/Link";
import { forwardRef, type ReactNode } from "react";
import { useProductDetailsUrl } from "~/features/PackageRestriction/hooks/useProductDetailsUrl";

interface Props extends BaseProductElementProps {
  as?: keyof JSX.IntrinsicElements;
  clickable?: boolean;
  linkProps?: LinkProps;
}

// @deprecated
export const Designation = forwardRef<HTMLElement, Props>((props, ref) => {
  const { clickable = true, linkProps } = props;
  const product = useProductContext(props);
  const Cmp = props.as ?? "div";

  let href: string | undefined = useProductDetailsUrl(product);
  if (linkProps?.href) {
    href = linkProps.href;
  }

  let content: ReactNode = product.designation;

  if (clickable && href) {
    content = (
      <Link href={href} variant={LinkType.SECONDARY} {...linkProps}>
        {content}
      </Link>
    );
  }

  return <Cmp className={props.className}>{content}</Cmp>;
});
